import { render, staticRenderFns } from "./automatic-translation.vue?vue&type=template&id=15c3f37a&scoped=true"
import script from "./automatic-translation.vue?vue&type=script&lang=js"
export * from "./automatic-translation.vue?vue&type=script&lang=js"
import style0 from "./automatic-translation.vue?vue&type=style&index=0&id=15c3f37a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3f37a",
  null
  
)

export default component.exports